<template>
  <div class="opsPersonManagement">
    <div class="centerStructure">
      <div class="searchBox">
        <span>关键字:</span>
        <el-input class="cname" v-model.trim="searchForm.keyword" placeholder="用户名或姓名" clearable></el-input>
        <span class="inp">状态:</span>
        <el-select class="el-select cname" v-model="searchForm.status" placeholder="选择状态">
          <el-option
              class="wh140"
              v-for="item in statusList"
              :key="item.id"
              :label="item.dictionaryName"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="getData" icon="el-icon-search">查询</el-button>
        <el-button type="primary" v-if="$root.$permissionMap.has('InsertOpsPerson')" @click="toSave"
                   icon="el-icon-circle-plus-outline">添加
        </el-button>
      </div>
      <el-table
          :data="tableData"
          border
          ref="singleTable"
          style="width: 100%"
          height="calc(100% - 84px)">
        <el-table-column
            fixed
            type="index"
            header-align="center"
            align="center"
            width="50">
          <template #header>
          </template>
        </el-table-column>
        <template v-for="item in tableTitle">
          <el-table-column
              :header-align="item.headerAlign"
              :align="item.align"
              :key="item.index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :formatter="item.formatter"
              :sortable="item.sortable"
              v-if="item.prop != 'operation' && item.prop != 'statusName'"
              show-overflow-tooltip>
          </el-table-column>

          <el-table-column
              :header-align="item.headerAlign"
              :align="item.align"
              :key="item.index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :formatter="item.formatter"
              :sortable="item.sortable"
              v-if="item.prop == 'statusName'"
              show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statusName!='正常'" style="color: #ff002b">{{ scope.row.statusName }}</span>
              <span v-else>{{ scope.row.statusName }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="item.prop == 'operation'" :label="item.label" :key="item.prop"
                           header-align="center" align="center" :width="item.width">
            <template slot-scope="scope">
              <span class="tableicon" v-show="$root.$permissionMap.has('UpdateOps')"><i @click="toModify(scope)"
                                                                                        class="el-icon-edit"></i></span>
              <span class="tableicon" v-show="$root.$permissionMap.has('DeleteOps')"><i @click="del(scope)"
                                                                                        class="el-icon-delete"></i></span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNumber"
          :page-sizes="[20, 50,100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next"
          :total="pagetotal">
      </el-pagination>
    </div>
    <el-dialog
        :title="title"
        :visible.sync="opendiaflag"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="680px"
    >
      <div class="formbox">
        <el-form
            :rules="rules"
            :model="userDetail"
            label-width="90px"
            ref="ruleForm">
          <!--客户-->
          <div class="lintit"><i></i><span>基础信息</span></div>
          <div class="inline" style="display:flex">
            <el-form-item label="用户名：" prop="loginName">
              <el-input class="wh200" v-model.trim="userDetail.loginName" placeholder="请输入用户名" :disabled="userNameFlag"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="userName">
              <el-input class="wh200" v-model.trim="userDetail.userName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </div>
          <div class="inline" style="display:flex">
            <el-form-item label="手机号码：" prop="telephone">
              <el-input class="wh200" v-model.trim="userDetail.telephone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <div class="inline" style="display:flex">
              <el-form-item label="状态：" prop="statusId">
                <el-select class="wh200" v-model="userDetail.statusId" placeholder="请选择状态">
                  <el-option
                          class="wh200"
                      v-for="item in detailStatusList"
                      :key="item.id"
                      :label="item.dictionaryName"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <!--客户-->
          <div class="lintit"><i></i><span>客户授权</span></div>
          <!--穿梭框-->
          <div class="customerTransferDiv">
            <template>
              <el-transfer
                  v-if="opendiaflag"
                  class="customerTransfer"
                  ref="customerTransfer"
                  filter-placeholder="请输入客户名称"
                  @change="customerChange"
                  v-model="okCustomerData"
                  filterable
                  :props="{key: 'id',label: 'customerName'}"
                  :titles="['未授权客户', '已授权客户']"
                  :data="customerList"
                  :render-content="renderFunc">
              </el-transfer>
            </template>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
         <el-button type="primary" @click="resetPassword()" v-show="showRentPrise">重置密码</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :disabled="submitFlag">提 交</el-button>

            </span>
    </el-dialog>
  </div>
</template>
<script>
import Tree from "@/components/common/Tree"
import {Mixins} from '@/config/mixins/mixins'
import {$http} from '@/config/api/axios'
import SearchDialog from '@/components/custom/Searchdialog'
import {dateChange} from "@/config/plugin/plugin";

export default {
  name: "opsPersonManagement",
  mixins: [Mixins],
  components: {
    SearchDialog,
    Tree,
  },
  data() {


    //时间格式化
    function timeFormat(value) {
      if (value.createTime == null || value.createTime == "") {
        return "";
      } else {
        return dateChange(value.createTime);
      }
    }

    function timeFormat2(value) {
      if (value.lastLoginTime == null || value.lastLoginTime == "") {
        return "";
      } else {
        return dateChange(value.lastLoginTime);
      }
    }

    return {
      //用户名禁用标志
      userNameFlag: false,


      leftChecked: [],
      rightChecked: [],
      //确认按钮
      submitFlag: false,

      //分页
      pageSize: 20, //条数
      pagetotal: 0, //总页数
      pageNumber: 1,//页码
      //状态列表
      statusList: [],
      //查询条件
      searchForm: {
        keyword: '',
        status
      },
      detailStatusList: [],
      //列表数据
      tableData: [],
      //详情
      userDetail: {
        id: '',
        loginName: '',
        userName: '',
        telephone: '',
        statusId: '',
        statusName: '',
        userId: '',
      },
      //需要运维客户
      okCustomerData: [],
      //全部客户
      customerList: [],
      mode: 1,//1新增0修改
      tableTitle: [
        {prop: "operation", label: '操作', width: '100', align: 'center', headerAlign: 'center', show: true},
        {prop: "userName", label: '姓名', width: '', align: 'left', headerAlign: 'center', show: true},
        {prop: "loginName", label: '用户名', width: '', align: 'left', headerAlign: 'center', show: false},
        {prop: "customerNames", label: '授权客户', width: '600px', align: 'left', headerAlign: 'center', show: false},
        {prop: "telephone", label: '手机号码', width: '160px', align: 'center', headerAlign: 'center', show: false},
        {prop: "statusName", label: '状态', width: '80px', align: 'center', headerAlign: 'center', show: false},
        {
          prop: "lastLoginTime",
          label: '末次登录时间',
          width: '160',
          align: 'center',
          headerAlign: 'center',
          show: true,
          sortable: true,
          'formatter': timeFormat2
        },
        {prop: "createUserName", label: '创建人', width: '100', align: 'center', headerAlign: 'center', show: false},
        {
          prop: "createTime",
          label: '创建时间',
          width: '160',
          align: 'center',
          headerAlign: 'center',
          show: true,
          sortable: true,
          'formatter': timeFormat
        },

      ],
      rules: {
        loginName: [
          {required: true, message: '用户名不能为空', trigger: 'blur'},
          {min: 1, max: 20, message: '长度不超过20个字符', trigger: 'blur'},
          {pattern: /^[A-Za-z0-9]+$/, message: "需为数字与字母", trigger: 'blur'}
        ],

        userName: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {pattern: /[^\s]+/, message: '姓名不能为空', trigger: 'blur'},

          {min: 1, max: 50, message: '长度不超过50个字符', trigger: 'blur'},
        ],
        telephone: [
          {required: false, message: ' ', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: "请正确输入手机号码", trigger: 'blur'}
        ],
        statusId: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ]
      },
      showRentPrise: true,
      title: '用户信息',
      opendiaflag: true
    }
  },
  watch: {},
  methods: {
    renderFunc(h, option) {
      return <span title={option.customerName}>{option.customerName}</span>;
    },
    //表单确认
    submitForm(ref) {
      //授权客户判断
      if (this.okCustomerData.length == 0) {
        this.$message({
          type: 'warning',
          message: "请选择授权客户。"
        });
        return;
      }
      this.submitFlag = true;
      this.$refs[ref].validate((valid) => {
        if (valid) {
          //新增
          if (this.mode == 1) {
            let param = {
              id: this.userDetail.id,
              loginName: this.userDetail.loginName,
              userName: this.userDetail.userName,
              telephone: this.userDetail.telephone,
              statusId: this.userDetail.statusId,
              statusName: this.userDetail.statusName,
              userId: this.userDetail.userId,
              list: JSON.stringify(this.okCustomerData)
            };
            $http("post", "opsPerson/insertOpsPerson", param).then(res => {
              if (res.status === 'SUCCESS') {
                this.$message({
                  type: 'success',
                  message: '新增成功,默认密码为：“111111”。'
                });
                this.submitFlag = false;
                this.search()
                this.opendiaflag = false;
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          } else {
            //修改
            let param = {
              id: this.userDetail.id,
              loginName: this.userDetail.loginName,
              userName: this.userDetail.userName,
              telephone: this.userDetail.telephone,
              statusId: this.userDetail.statusId,
              statusName: this.userDetail.statusName,
              userId: this.userDetail.userId,
              list: JSON.stringify(this.okCustomerData)
            };

            $http("post", "opsPerson/updateOps", param).then(res => {
              if (res.status === 'SUCCESS') {
                this.$message({
                  type: 'success',
                  message: res.message
                });
                this.opendiaflag = false;
                this.submitFlag = false;
                this.search();
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          }
        } else {
          this.$nextTick(() => {
            var isError = document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          });
          return false;
        }
      })
      this.$nextTick(() => {
        this.submitFlag = false;
      });
    },
    //查全部客户 与以管理客户并赋值
    getCustomer(id) {
      //customerFlag 为0时查授权客户，为1时查授权客户与全部客户,为2时查全部客户
      let param = {};
      param.id = id;
      if (id == null) {
        param.customerFlag = 2;
      } else {
        param.customerFlag = 0;
      }
      this.okCustomerData = [];
      $http("get", "opsPerson/listCustomers", param).then(res => {
        let okCustomerList = res.data.okCustomer;
        if (param.customerFlag == 2) {
          //全部客户
          this.customerList = res.data.allCustomer;
        } else {
          for (let i = 0; i < okCustomerList.length; i++) {
            this.okCustomerData.push(okCustomerList[i].customerId);
          }
        }
      })
    },
    //状态列表
    getStatusList() {
      let param = {
        typeId: 1005
      }
      $http("get", "dictionary/listDictionaryByTypeId", param).then(res => {
        this.detailStatusList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          this.statusList.push(res.data[i])
        }
        this.statusList.unshift({"id": '', "dictionaryName": "全部"});
      })
    },
    //客户穿梭框
    customerChange(value, direction, movedKeys) {
      //右移
      if (direction == "right") {
        for (let j = 0; j < movedKeys.length; j++) {
          //遍历customerData
          let flag = true;
          for (let i = 0; i < this.okCustomerData.length; i++) {
            if (this.okCustomerData[i] == movedKeys[j]) {
              //已经存在该值
              flag = false;
            }
          }
          if (flag) {
            this.okCustomerData.push(movedKeys[j]);
          }
        }
      } else {
        //左移
        for (let j = 0; j < movedKeys.length; j++) {
          for (let i = 0; i < this.okCustomerData.length; i++) {
            if (this.okCustomerData[i] == movedKeys[j]) {
              this.okCustomerData.splice(i, 1);
            }
          }
        }
      }
    },
    //查询按钮
    search() {
      this.selfLoadingOpen('.centerStructure')
      let param = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        keyword: this.searchForm.keyword.trim(),
        status: this.searchForm.status == 0 ? null : this.searchForm.status
      }
      $http("get", "opsPerson/listOpsPerson", param).then(res => {
        if (res.status == 'SUCCESS') {
          this.tableData = res.data;
          this.pagetotal = res.count;
        }else if(res.status == 'NORESOURCES'){
          this.tableData = [];
          this.pagetotal =0;
        }
        this.selfLoadingClose();
      })

    },
    getData() {
      this.pageNumber = 1;

      this.handleCurrentChange(1);
    },
    toModify(scope) {
      this.showRentPrise = true;
      this.userNameFlag = true;
      if (this.$refs['ruleForm'] != null) {
        this.$refs['ruleForm'].resetFields();
      }
      this.getCustomer(scope.row.id);
      this.mode = 0,//1新增0修改
          this.userId = scope.row.id;
      this.submitFlag = false;
      let param = {
        userId: this.userId
      }
      let _this = this;
      $http("get", "user/getDetail", param).then(res => {
        _this.userDetail.id = res.data.id;
        _this.userDetail.loginName = res.data.loginName;
        _this.userDetail.userName = res.data.userName;
        _this.userDetail.telephone = res.data.telephone;
        _this.userDetail.statusId = res.data.statusId;
        _this.userDetail.statusName = res.data.statusName;
        _this.userDetail.userId = res.data.userId;
        this.opendiaflag = true;
      })


    },
    resetPassword() {
      this.$confirm('重置后密码将变为111111，确认要重置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        if(this.userDetail.id==null){
          this.$message({
            type: 'error',
            message: '重置失败。'
          });
          return;
        }
        let id = this.userDetail.id
        let param = {
          userId: id
        }
        $http("post", "user/resetPassword", param).then(res => {
          if (res.status == 'SUCCESS') {
            this.$message({
              type: 'success',
              message: '重置成功。'
            });

          } else {
            this.$message({
              type: 'error',
              message: '重置失败。'
            });
          }
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置。'
        });
      });
    },
    toSave() {
      this.userNameFlag = false;
      if (this.$refs['ruleForm'] != null) {
        this.$refs['ruleForm'].resetFields();
      }
      this.userDetail.id=null;
      this.leftChecked = [];
      this.rightChecked = [];
      this.getCustomer(null);
      this.userDetail.statusId = 1005001;
      this.mode = 1;//1新增0修改
      this.opendiaflag = true;
      this.showRentPrise = false;
    },
    del(scope) {
      this.$confirm('删除后不能恢复，确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          id: scope.row.id
        }
        $http("post", "opsPerson/deleteOps", param).then(res => {
          if (res.status == 'SUCCESS') {
            this.$message({
              type: 'success',
              message: res.message
            });
            if (this.tableData.length == 1 && this.pageNumber > 1) {
              this.pageNumber = this.pageNumber - 1;
            }
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        });
      })
    },


    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.search();
    },
    resetForm(ref) {
      if (this.mode == 1) {
        this.$refs[ref].resetFields();
      }
      this.opendiaflag = false;
    },
    setDefaultDetailForm() {
      this.userDetail =
          {
            id: '',
            loginName: '',
            userName: '',
            telephone: '',
            statusId: '',
            statusName: '',
            userId: '',
          }
    }
  },
  created() {
    this.search();
    this.getStatusList();
    this.setDefaultDetailForm();
    this.getCustomer(null);
    this.$nextTick(() => {
      this.opendiaflag = false;
    });
  },
  mounted() {

  },
  activated() {
    this.$refs.singleTable.doLayout() // 路由切换时对table重新布局啊
  },
}
</script>

<style lang="less">
.opsPersonManagement {
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;

  .centerStructure {
    .searchBox {
      .cname {
        margin-left: 10px;
      }
    }
  }

  .tableicon {
    cursor: pointer;
    margin: 0 8px;
    color: #4980d7;
  }

  .customerTransferDiv {
    text-align: center;

    .customerTransfer {
      text-align: left;
      display: inline-block;
      width: 100%;

      .el-transfer-panel {
        width: 230px;
      }

      .el-transfer__buttons {
        width: 175px;

        .el-transfer__button {
          margin-left: 10px;
        }
      }
    }
  }
}

</style>